import api from "../../api";
import { Suspense, useState, useEffect } from "react";
import { useParams } from "react-router";
import SimpleTable from "../../components/SimpleTable";
import Link from "../../components/Link";
import { AdminContainer } from "../../components/layouts";
import Time from "../../lithic/Moment";
import Money from "../../lithic/Money";

export default function PartnerPayoutsPage() {
  const { id } = useParams();
  const [payouts, setPayouts] = useState([]);

  useEffect(() => {
    if (id) {
      api.getPartnerPayouts({ id }).then(api.pick("data.items")).then(setPayouts);
    }
  }, [id]);

  return (
    <AdminContainer variant="list">
      <Suspense fallback={<div>Loading...</div>}>
        <SimpleTable
          tableProps={{ size: "small" }}
          headers={["ID", "Status", "Amount", "Begin", "End"]}
          rows={payouts}
          keyRowAttr="id"
          toCells={(row) => [
            <Link key={1} to={`/partner/payouts/${row.id}`}>
              {row.id}
            </Link>,
            <Link key={4} to={`/partner/payouts/${row.id}`}>
              {row.status === "settled" ? "paid" : "unpaid"}
            </Link>,
            <Money key={2} value={row.total} />,
            <Time key={5} format={"MMM DD, YYYY HH:mm:ss"} timezone="Etc/GMT+5">
              {row.period.start}
            </Time>,
            <Time key={6} format={"MMM DD, YYYY HH:mm:ss"} timezone="Etc/GMT+5">
              {row.period.end}
            </Time>,
          ]}
        />
      </Suspense>
    </AdminContainer>
  );
}
